import React, { FC, ReactNode } from "react";
import { OpsTechMessage } from "@/common/components/OpsTechMessage/ops-tech-message";
import { useUserInfo } from "@/common/providers/user-info-provider";

interface OpsEmployeeGateProps {
  children: ReactNode;
}

export const OpsEmployeeGate: FC<OpsEmployeeGateProps> = ({ children }) => {
  const { jobInfo } = useUserInfo();
  return jobInfo.isOPSEmployee === false ? <>{children}</> : <OpsTechMessage />;
};
